export default __webpack_public_path__ + "static/media/success.403936cf.gif";